// @core/api/endpoints/attachment/update_attachment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachmentResponse,
  UpdateAttachmentRequest,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Update attachment metadata
 * Updates attachment metadata such as name, description, and custom metadata. Does not modify the actual file content.
 */
export async function UpdateAttachment(
  attachment_id: string,
  data: UpdateAttachmentRequest,
  options?: RequestOptions
): Promise<AttachmentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/:attachment_id`;
  requestPath = requestPath.replace(':attachment_id', encodeURIComponent(attachment_id));
  const requestOptions = options;
  return client.put<AttachmentResponse>(requestPath, data, requestOptions);
}
